import { observable, runInAction } from 'mobx'
import posts, { Post } from '../mocks/posts'
import GlobalState from './GlobalState'

type PostModelType = {
  posts: null | Array<Post>
  post: null | Post
}
const PostModel: PostModelType = observable({
  posts: null,
  post: null,
})
export default PostModel

export const getPosts = async (lang: string) => {
  try {
    const fd = new FormData()
    fd.append('status', 'news')
    fd.append('lang', lang)
    const request = await fetch(
      GlobalState.domain,
      {
        method: 'POST',
        body: fd,
      },
    )
    const response = await request.json()
    runInAction(() => {
      PostModel.posts = response
    })
  } catch (e) {
    console.log(e)
  }
}

export const getPostById = async (id: number, lang: string) => {
  try {
    const fd = new FormData()
    fd.append('status', 'news')
    fd.append('lang', lang)
    const request = await fetch(
      GlobalState.domain,
      {
        method: 'POST',
        body: fd,
      },
    )
    const response = await request.json()
    runInAction(() => {
      PostModel.post = response?.find((p: any) => p.id == id) || null
    })
  } catch (e) {
    console.log(e)
  }
}
